module.exports = __webpack_public_path__ + "static/media/10.983488b3.jpg";